import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalService } from '../services/global.service';

const states: Record<string, [string,string,string]> = {
  records:['fa-inbox','NOTHING_TO_SHOW_YET','ITEMS_WILL_APPEAR_HERE_WHEN_THEY_ARE_AVAILABLE'],
  notifications:['fa-bell','NO_NOTIFICATIONS_YET','NEW_CHURCH_NOTIFICATIONS_AND_REMINDERS_WILL_APPEAR_HERE'],
  signin:['fa-user','SIGN_IN_TO_VIEW_NOTIFICATIONS','YOUR_NOTIFICATIONS_ARE_AVAILABLE_AFTER_YOU_SIGN_IN'],
  reservations:['fa-ticket-alt','NO_RESERVATIONS_YET','YOUR_EVENT_RESERVATIONS_WILL_APPEAR_HERE_AFTER_YOU_RESERVE_A_PLACE'],
  groups:['fa-users','NO_GROUPS_TO_SHOW','YOUR_HOUSEHOLD_S_GROUPS_AND_INVITATIONS_WILL_APPEAR_HERE_WHEN_AVAILABLE'],
  forms:['fa-file-alt','NO_FORMS_AVAILABLE','FORMS_AVAILABLE_TO_YOUR_ACCOUNT_WILL_APPEAR_HERE'],
  submissions:['fa-clipboard-list','NO_FORM_SUBMISSIONS_YET','SUBMITTED_FORMS_WILL_APPEAR_HERE_WHEN_AVAILABLE'],
  unavailable:['fa-file-alt','THIS_FORM_IS_UNAVAILABLE','CHECK_THE_LINK_OR_ASK_YOUR_CHURCH_FOR_THE_CURRENT_FORM'],
  notes:['fa-sticky-note','NO_NOTES_YET','NOTES_FOR_THIS_MEMBER_WILL_APPEAR_HERE_WHEN_ADDED'],
  tasks:['fa-clipboard-list','NO_OUTREACH_TASKS_TO_SHOW','YOUR_ASSIGNED_OUTREACH_TASKS_WILL_APPEAR_HERE'],
  contacts:['fa-users','NO_LINKED_FAMILY_CONTACTS','LINKED_FAMILY_ACCOUNTS_WILL_APPEAR_HERE_WHEN_AVAILABLE'],
  tags:['fa-tags','NO_TAGS_YET','USE_ADD_TAG_BELOW_TO_ORGANIZE_THIS_MEMBER'],
  contents:['fa-folder-open','NO_CONTENT_YET','CONTENT_ADDED_TO_THIS_FOLDER_WILL_APPEAR_HERE'],
  links:['fa-link','NO_LINKS_YET','LINKS_ADDED_TO_THIS_SECTION_WILL_APPEAR_HERE'],
  birthdays:['fa-birthday-cake','NO_BIRTHDAYS_MATCH_YOUR_SELECTION','TRY_ANOTHER_DATE_RANGE_OR_CHANGE_YOUR_FILTERS'],
  attendees:['fa-user-check','NO_ATTENDEES_TO_SHOW','ATTENDEES_FOR_THIS_EVENT_WILL_APPEAR_HERE_WHEN_AVAILABLE'],
  volunteering:['fa-hands-helping','NO_VOLUNTEERING_SLOTS_YET','SLOTS_WILL_APPEAR_HERE_WHEN_ADDED_TO_THIS_SETUP_SHEET'],
  events:['fa-calendar','NO_EVENTS_MATCH_YOUR_SELECTION','TRY_ANOTHER_DATE_OR_CHANGE_YOUR_FILTERS']
};

@Component({selector:'app-empty-state', standalone:true, imports: [CommonModule],
  templateUrl:'./empty-state.component.html', styleUrls:['./empty-state.component.scss']})
export class EmptyStateComponent {
  @Input() kind = 'records';
  @Input() title = '';
  @Input() message = '';
  @Input() actionLabel = '';
  @Output() action = new EventEmitter<void>();
  constructor(public globalService: GlobalService) {}
  private get copy() { return states[this.kind] || states.records; }
  get icon() { return this.copy[0]; }
  get heading() { return this.title || this.globalService.Get(this.copy[1]); }
  get description() { return this.message || this.globalService.Get(this.copy[2]); }
}
